import React from "react";
import "./WaterQualityCard.css";

const WaterQualityCard = ({ param, value, unit, status }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case "Excellent": return "#8fce00";
      case "Good": return "#39a78e";
      case "Fair": return "#ffa500";
      case "Poor": return "#ff6b6b";
      default: return "#999";
    }
  };

  const Icon = param.icon;
  const color = getStatusColor(status);

  return (
    <div
      className="water-quality-card"
      style={{
        background: `linear-gradient(135deg, ${color}33 0%, ${color}66 100%)`,
        boxShadow: `0px 10px 20px 0px ${color}44`,
      }}
    >
      <div className="water-quality-card-header">
        <Icon size={28} color={color} />
        <span
          className="water-quality-status-badge"
          style={{ backgroundColor: color }}
        >
          {status}
        </span>
      </div>
      <div className="water-quality-card-content">
        <span className="water-quality-param-name">{param.name}</span>
        <span className="water-quality-value" style={{ color }}>
          {value}
        </span>
        <span className="water-quality-unit">{unit}</span>
      </div>
    </div>
  );
};

export default WaterQualityCard;